// New-order chime, synthesised with the Web Audio API so there is no audio
// file to host or preload.
//
// Browsers refuse to start audio until the page has had a click or key press,
// so the context is created (and resumed) on the first interaction. Staff
// always log in first, which counts, so in practice the chime is ready before
// the first order lands.

const MUTE_KEY = 'borku-order-sound-muted'

let context = null

const getContext = () => {
  if (context) return context
  const AudioContextClass = window.AudioContext || window.webkitAudioContext
  if (!AudioContextClass) return null
  context = new AudioContextClass()
  return context
}

const unlock = () => {
  const ctx = getContext()
  if (ctx && ctx.state === 'suspended') ctx.resume().catch(() => {})
}

if (typeof window !== 'undefined') {
  ;['pointerdown', 'keydown', 'touchstart'].forEach(eventName =>
    window.addEventListener(eventName, unlock, { passive: true })
  )
}

export const isOrderSoundMuted = () => {
  try {
    return localStorage.getItem(MUTE_KEY) === '1'
  } catch (e) {
    return false
  }
}

export const setOrderSoundMuted = muted => {
  try {
    localStorage.setItem(MUTE_KEY, muted ? '1' : '0')
  } catch (e) {
    // Storage unavailable - the choice just won't survive a reload.
  }
}

const tone = (ctx, frequency, start, duration) => {
  const oscillator = ctx.createOscillator()
  const gain = ctx.createGain()
  oscillator.type = 'sine'
  oscillator.frequency.setValueAtTime(frequency, start)
  // Short attack and exponential release, so each note is a clean "ding"
  // instead of a click.
  gain.gain.setValueAtTime(0.0001, start)
  gain.gain.exponentialRampToValueAtTime(0.35, start + 0.02)
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration)
  oscillator.connect(gain)
  gain.connect(ctx.destination)
  oscillator.start(start)
  oscillator.stop(start + duration + 0.05)
}

// Three rising two-note chimes (~2.5s): long enough to be noticed across a
// room, short enough not to be irritating on a busy day.
export const playNewOrderSound = ({ force = false } = {}) => {
  if (!force && isOrderSoundMuted()) return
  const ctx = getContext()
  if (!ctx) return
  if (ctx.state === 'suspended') ctx.resume().catch(() => {})
  const now = ctx.currentTime + 0.05
  for (let i = 0; i < 3; i++) {
    const start = now + i * 0.8
    tone(ctx, 880, start, 0.3)
    tone(ctx, 1320, start + 0.18, 0.45)
  }
}
